export default __webpack_public_path__ + "static/media/banner-iqac.49df81f0.webp";